<div  
  class="app-button"
  [ngClass]="{ 
    'app-button--xsmall': buttonSize == 'xsmall',
    'app-button--small': buttonSize == 'small',
    'app-button--medium': buttonSize == 'medium',
    'app-button--large': buttonSize == 'large',
    'app-button--flat': buttonType == 'flat',
    'app-button--default': buttonType == 'default',
    'app-button--primary': buttonType == 'primary',
    'app-button--outline': buttonType == 'outline',
    'app-button--text': buttonType == 'text',
    'app-button--light': buttonTheme == 'light',
    'app-button--dark': buttonTheme == 'dark',
    'app-button--circle': buttonShape == 'circle',
    'app-button--selected': selected,
    'app-button--uppercase': uppercase,
    'app-button--disabled': disabled,
    'app-button--no-border': !bordered,
    'app-button--expanded': expanded,
    'app-button--left': buttonAlign === 'left'
  }">

  <div class="app-button__container">
    <ng-content></ng-content>
  </div>
</div>
